import type { PaxtonHighlightArea } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'
import type { ClientAgentReference } from '../store/schemas'

/**
 * Returns the highlights for a chat citation occurrence.
 *
 * A reference can be cited more than once in one response. When no occurrence
 * index is requested, sentence highlights are merged for the reference-list row.
 */
export function getHighlightsForCitation(
  reference: ClientAgentReference,
  citationHighlightIndex?: number
): { sentences: string[] | undefined; areas: PaxtonHighlightArea[] } {
  if (!('highlighted_citations' in reference)) {
    return {
      sentences: undefined,
      areas: [],
    }
  }

  if (citationHighlightIndex === undefined) {
    const allSentences: string[] = []

    reference.highlighted_citations.forEach((citation) => {
      if (citation.sentences) {
        allSentences.push(...citation.sentences)
      }
    })

    const uniqueSentences = Array.from(new Set(allSentences))

    return {
      sentences: uniqueSentences.length > 0 ? uniqueSentences : undefined,
      areas: [],
    }
  }

  const highlightedCitation = reference.highlighted_citations[citationHighlightIndex]

  return {
    sentences: highlightedCitation?.sentences ?? undefined,
    areas: highlightedCitation?.highlights ?? [],
  }
}
